import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";

export default class AuthStore {
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  login = (userName: string, password: string, callback: Function) => {
    Api.post(
      ApiConfig.REST_URIS.auth.login,
      { userName, password, rememberMe: true },
      (res: ApiResponse<string>) => {
        callback && callback(res?.isSuccess, res.data);
      }
    );
  };

  register = (user: IUserCommand, callback: Function) => {
    Api.post(
      ApiConfig.REST_URIS.auth.register,
      user,
      (res: ApiResponse<string>) => {
        callback && callback(res);
      }
    );
  };

  forgotPassword = (email: string, callbackUrl: string, callback: Function) => {
    Api.post(
      ApiConfig.REST_URIS.auth.forgotpassword,
      { email, callbackUrl },
      (res: ApiResponse<boolean>) => {
        callback && callback(res?.isSuccess, res.data);
      }
    );
  };

  resetPassword = (
    userId: string,
    code: string,
    password: string,
    callback: Function
  ) => {
    Api.post(
      ApiConfig.REST_URIS.auth.resetPassword,
      { userId, code, password, confirmPassword: password },
      (res: ApiResponse<boolean>) => {
        callback && callback(res?.isSuccess, res.data);
      }
    );
  };
}
